import { render, staticRenderFns } from "./UnauthorizedDomainList.vue?vue&type=template&id=0c498b8c&"
import script from "./UnauthorizedDomainList.vue?vue&type=script&lang=js&"
export * from "./UnauthorizedDomainList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports